<template>
    <popup-modal ref="popup">
        <div
            class="dialog-content"
            :class="variant ? ['dialog-alert', 'dialog-' + variant] : null"
            :role="variant ? 'alertdialog' : 'dialog'"
            aria-modal="true"
            :aria-label="title"
            aria-describedby="confirmare-mesaj"
        >
            <h2 class="dialog-title" style="margin-top: 0">{{ title }}</h2>
            <p id="confirmare-mesaj" class="dialog-message">{{ message }}</p>
            <div class="btns">
                <button v-if="cancelButton" class="cancel-btn2" type="button" @click="_cancel">{{ cancelButton }}</button>
                <button ref="okButton" :class="variant ? ['btn', 'btn-' + variant] : 'ok-btn'" type="button" @click="_confirm">{{ okButton }}</button>
            </div>
        </div>
    </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue'

export default {
    name: 'Confirmare',

    components: { PopupModal },

    data: () => ({
        // Parameters that change depending on the type of dialogue
        title: undefined,
        message: undefined, // Main text content
        okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
        cancelButton: 'Da - înapoi', // text for cancel button
        variant: undefined,

        // Private variables
        resolvePromise: undefined,
        rejectPromise: undefined,
    }),

    methods: {
        show(opts = {}) {
            this.title = opts.title
            this.message = opts.message
            this.okButton = opts.okButton
            this.cancelButton = opts.cancelButton === undefined ? 'Da - înapoi' : opts.cancelButton
            this.variant = opts.variant
            // Once we set our config, we tell the popup modal to open
            this.$refs.popup.open()
            if (this.variant) {
                this.$nextTick(() => this.$refs.okButton.focus())
            }
            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },

        _confirm() {
            this.$refs.popup.close()
            this.resolvePromise(true)
        },

        _cancel() {
            this.$refs.popup.close()
            this.resolvePromise(false)
            // Or you can throw an error
            // this.rejectPromise(new Error('User canceled the dialogue'))
        },
    },
}
</script>

<style scoped>
.dialog-content {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.dialog-title {
    flex-shrink: 0;
    overflow-wrap: anywhere;
}

.dialog-message {
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.dialog-alert {
    padding: 1rem;
    border-top: 6px solid;
    border-radius: 5px;
}

.dialog-danger {
    color: #842029;
    background-color: #f8d7da;
    border-color: #dc3545;
}

.dialog-warning {
    color: #664d03;
    background-color: #fff3cd;
    border-color: #ffc107;
}

.btns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-shrink: 0;
    gap: 12px;
}

.btns > button {
    min-height: 48px;
    min-width: 72px;
}

.ok-btn {
    padding: 0;
    border: none;
    background: transparent;
    color: rgb(6, 139, 6);
    text-decoration: underline;
    line-height: 2.5rem;
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
}

.cancel-btn {
    padding: 0.5em 1em;
    background-color: #d5eae7;
    color: #35907f;
    border: 2px solid #0ec5a4;
    border-radius: 5px;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;
}
.cancel-btn2{
    padding: 0.5em 1em;
    background-color: #d5eae7;
    color: #0c5692;
    border: 2px solid #891bb4;
    border-radius: 5px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}

@media (max-width: 575px) {
    .dialog-content {
        text-align: left;
    }

    .dialog-title {
        font-size: 1.375rem;
        line-height: 1.25;
        margin-bottom: 12px;
    }

    .dialog-alert {
        padding: 12px;
    }

    .dialog-message {
        font-size: 1rem;
        line-height: 1.5;
    }

    .dialog-alert .btns > button {
        width: 100%;
    }
}
</style>
